/* Staffelkorting: zet het aantal in het eigen formulier en houdt de prijzen
   bij als de klant een andere variant (maat) kiest. Raakt verder niets aan. */
(function () {
  if (window.__staffelInit) return;
  window.__staffelInit = true;

  function formatMoney(cents, format) {
    format = format || '€{{amount_with_comma_separator}}';
    const amount = (cents / 100).toFixed(2);
    const [whole, dec] = amount.split('.');
    const group = (sep) => whole.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    const values = {
      amount: group(',') + '.' + dec,
      amount_no_decimals: group(','),
      amount_with_comma_separator: group('.') + ',' + dec,
      amount_no_decimals_with_comma_separator: group('.'),
      amount_with_space_separator: group(' ') + ',' + dec,
      amount_with_period_and_space_separator: group(' ') + '.' + dec,
      amount_no_decimals_with_space_separator: group(' '),
      amount_with_apostrophe_separator: group("'") + '.' + dec,
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, (m, key) => (key in values ? values[key] : m));
  }

  function updatePrices(block, price) {
    if (!block || isNaN(price)) return;
    block.dataset.price = price;
    const format = block.dataset.moneyFormat;
    block.querySelectorAll('.staffel__option').forEach((opt) => {
      const qty = parseInt(opt.dataset.qty, 10) || 1;
      const pct = parseFloat(opt.dataset.pct) || 0;
      const full = price * qty;
      const disc = Math.round((full * pct) / 100);
      opt.querySelector('.staffel__price-now').textContent = formatMoney(full - disc, format);
      const old = opt.querySelector('.staffel__price-old');
      old.textContent = formatMoney(full, format);
      old.hidden = disc === 0;
    });
  }

  function select(radio) {
    const block = radio.closest('.staffel');
    const field = block.querySelector('.staffel__qty');
    if (field) field.value = radio.value;
    block.querySelectorAll('.staffel__option').forEach((o) =>
      o.classList.toggle('is-selected', o.contains(radio))
    );
  }

  document.addEventListener('change', (e) => {
    if (e.target.matches('.staffel__radio')) select(e.target);
  });

  document.addEventListener('DOMContentLoaded', () => {
    // Na terug-knop in de browser kan een andere keuze aangevinkt zijn: synchroniseren.
    document.querySelectorAll('.staffel__radio:checked').forEach(select);

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const variant = event && event.data && event.data.variant;
        if (!variant) return;
        document.querySelectorAll('.staffel').forEach((b) => updatePrices(b, variant.price));
      });
    }
  });
})();
